/**
 * Privileged access check — replaces hardcoded email bypasses.
 *
 * DECISION: Platform-owner emails are still the source of truth for
 * "unconditional access" (super-admin tier). However, the CHECK is
 * centralised here rather than scattered across 9 files.
 *
 * MIGRATION PATH:
 *   1. Today: email-list check (same behaviour, single location)
 *   2. Future: replace with user_roles.role = 'super_admin' DB check
 *
 * RULE: Only import this module where "bypass all subscription/access
 * checks" is needed. Normal admin/driver role checks should use
 * useUserRole() which reads from the user_roles table.
 */

/** Emails that bypass ALL subscription and access checks */
const PRIVILEGED_EMAILS: ReadonlySet<string> = new Set([
  "aaron@transportmate.co.uk",
  "ajleaney@me.com",
]);

/**
 * Returns true if this email has unconditional platform access.
 * Used by ProtectedRoute, SubscriptionGate, and subscription hooks
 * to skip subscription verification.
 */
export function isPlatformPrivileged(email: string | null | undefined): boolean {
  if (!email) return false;
  return PRIVILEGED_EMAILS.has(email.toLowerCase());
}
